import NavbarWrapper from './Navbar/Navbar';
import NavbarAction from './NavbarAction/NavbarAction';

export default Object.assign(NavbarWrapper, { Action: NavbarAction });

export { navbarLinkStyles } from './NavbarLink/NavbarLink';
